import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

function Confirmation() {
  const { signOut } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const isUnavailable = new URLSearchParams(location.search).get('reason') === 'unavailable';

  const handleSignOut = async () => {
    try {
      await signOut();
      navigate('/');
    } catch (error) {
      console.error('Sign out error:', error);
    }
  };

  if (isUnavailable) {
    return (
      <div className="container">
        <div className="card">
          <div className="card-header">
            <div style={{ fontSize: '4rem', marginBottom: '20px' }}>😔</div>
            <h1 className="card-title">Thanks for Letting Us Know</h1>
            <p className="card-subtitle">
              We understand you can't make it for MLK weekend. No worries!
            </p>
          </div>

          <div style={{ 
            background: '#f0f9ff', 
            padding: '20px', 
            borderRadius: '12px', 
            marginBottom: '30px',
            border: '1px solid #bae6fd'
          }}>
            <p style={{ margin: 0, color: '#0ea5e9', fontWeight: '600' }}>
              We'll keep you in mind for future trips!
            </p>
            <p style={{ margin: '10px 0 0 0', fontSize: '0.9rem', color: '#0ea5e9' }}>
              If your plans change, feel free to reach out to the trip organizer.
            </p>
          </div>

          <div className="navigation">
            <button
              type="button"
              className="btn btn-secondary"
              onClick={handleSignOut}
            >
              Sign Out
            </button>
            <button
              type="button"
              className="btn btn-secondary"
              onClick={() => navigate('/home')}
            >
              🏠 Home
            </button>
            <button
              type="button"
              className="btn btn-primary"
              onClick={() => navigate('/edit-responses')}
            >
              Change My Response
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="container">
      <div className="card">
        <div className="card-header">
          <div style={{ fontSize: '4rem', marginBottom: '20px' }}>⏳</div>
          <h1 className="card-title">You're on the Waitlist!</h1>
          <p className="card-subtitle">
            Thank you for your interest in the Whistler trip!
          </p>
        </div>

        <div style={{ 
          background: '#fff3cd', 
          padding: '20px', 
          borderRadius: '12px', 
          marginBottom: '30px',
          border: '2px solid #ffc107'
        }}>
          <p style={{ margin: 0, fontWeight: '600', color: '#856404' }}>
            Your response has been recorded and you've been added to the waitlist.
          </p>
          <p style={{ margin: '10px 0 0 0', fontSize: '0.9rem', color: '#856404' }}>
            We'll contact you if spots become available. Thank you for your patience!
          </p>
        </div>

        <div style={{ 
          background: '#f7fafc', 
          padding: '20px', 
          borderRadius: '12px', 
          marginBottom: '30px',
          border: '1px solid #e2e8f0'
        }}>
          <h3 style={{ 
            color: '#2d3748', 
            marginBottom: '15px', 
            fontSize: '1.1rem',
            fontWeight: '600'
          }}>
            What happens next?
          </h3>
          <ul style={{ 
            color: '#4a5568', 
            lineHeight: '1.6',
            paddingLeft: '20px'
          }}>
            <li>We'll review everyone's responses</li>
            <li>Find the best dates that work for the group</li>
            <li>Research accommodation options within budget ranges</li>
            <li>Send out final trip details and booking information</li>
          </ul>
        </div>

        <div className="navigation">
          <button
            type="button"
            className="btn btn-secondary"
            onClick={handleSignOut}
          >
            Sign Out
          </button>
          <button
            type="button"
            className="btn btn-secondary"
            onClick={() => navigate('/trip-details')}
          >
            View Trip Details
          </button>
          <button
            type="button"
            className="btn btn-secondary"
            onClick={() => navigate('/carpools', { state: { from: '/confirmation' } })}
          >
            View Carpools
          </button>
          <button
            type="button"
            className="btn btn-secondary"
            onClick={() => navigate('/home')}
          >
            🏠 Home
          </button>
          <button
            type="button"
            className="btn btn-primary"
            onClick={() => navigate('/edit-responses')}
          >
            Change My Responses
          </button>
        </div>

        <div style={{ 
          textAlign: 'center', 
          marginTop: '30px', 
          padding: '20px',
          background: '#f7fafc',
          borderRadius: '12px',
          border: '1px solid #e2e8f0'
        }}>
          <p style={{ 
            color: '#718096', 
            fontSize: '0.9rem',
            margin: 0
          }}>
            Questions? Contact the trip organizer or check back for updates!
          </p>
        </div>
      </div>
    </div>
  );
}

export default Confirmation;
